import React from 'react';
import PropTypes from 'prop-types';
import './authlayout.scss';

export function HealthCheckLayout(props) {
  const { children } = props;

  return <div>{children}</div>;
}

HealthCheckLayout.propTypes = {
  children: PropTypes.node.isRequired
};
